import styled from 'styled-components'
import { InvoiceTemplate } from '../../../api/dto/invoice-delivery.dto'

interface TagPalette {
  background: string
  border: string
  color: string
}

const TEMPLATE_TAG_PALETTE: Record<InvoiceTemplate, TagPalette> = {
  [InvoiceTemplate.MONTHLY]: {
    background: '#f3f4f6',
    border: '#e5e7eb',
    color: '#4b5563',
  },
  [InvoiceTemplate.INITIAL_OE]: {
    background: '#ecfdf5',
    border: '#a7f3d0',
    color: '#047857',
  },
  [InvoiceTemplate.OE_FIRST]: {
    background: '#eff6ff',
    border: '#bfdbfe',
    color: '#1d4ed8',
  },
  [InvoiceTemplate.OE_FINAL]: {
    background: '#eef2ff',
    border: '#c7d2fe',
    color: '#4338ca',
  },
}

/* ---------- Template tag ---------- */

export const TemplateTagPill = styled.span<{ $template: InvoiceTemplate }>`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  max-width: 100%;
  padding: 0 7px;
  height: 20px;
  border-radius: 4px;
  border: 1px solid ${({ $template }) => TEMPLATE_TAG_PALETTE[$template].border};
  background: ${({ $template }) => TEMPLATE_TAG_PALETTE[$template].background};
  color: ${({ $template }) => TEMPLATE_TAG_PALETTE[$template].color};
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.02em;
  line-height: 18px;
  white-space: nowrap;
  cursor: default;

  &:focus-visible {
    outline: 2px solid #6366f1;
    outline-offset: 1px;
  }
`

export const TemplateTagDivider = styled.span`
  opacity: 0.55;
  font-weight: 500;
`

/* "OE1 × 2 · OE2 × 1" in the floating bulk bar. */
export const SelectedTemplates = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 10px;
  font-size: 12px;
  white-space: nowrap;
`

export const SelectedTemplateCount = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
`
